import { render } from "./Requirements.vue?vue&type=template&id=a30335dc&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"

import "./Requirements.vue?vue&type=style&index=0&id=a30335dc&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a30335dc"]])

export default __exports__